export default __webpack_public_path__ + "static/media/img_post6_3.3d3ce500.png";